import {defineStore} from 'pinia';
import {ModuleBankInfo} from './../moduleConst';
import BankInfoAPI from '@/apis/di/bankInfoAPI';
import {BaseDictionaryStore} from './../baseDictionaryStore';
const BankInfoStore = new BaseDictionaryStore(BankInfoAPI);

export const useBankInfoStore = defineStore(ModuleBankInfo, {
  state: () => ({
    ...BankInfoStore.state,
    _config: {
      key: 'bank_id',
      code: 'bank_account',
      name: 'bank_name',
      table: 'di_bank_info',
      moduleName: 'Tài khoản ngân hàng',
      quickFollow: 'active',
      defaultSort: 'bank_account',
    },
    moduleName: 'bank_info',
  }),
  actions: {
    ...BankInfoStore.action,
    /**
     * Hàm cung cấp dữ liệu stock cho store khác muốn dùng
     * @returns
     */
    provideDataBankInfo() {
      return this.$state.items;
    },
  },
  getters: {
    ...BankInfoStore.getters,
  },
});
